var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as React from "react";
import { AuthContextType } from "@ane/core/lib/services/MSALAuthService/IAuthContext";
function withAuthContext(component) {
  var _a;
  return _a = class extends React.Component {
    constructor(props) {
      super(props);
      __publicField(this, "context");
    }
    render() {
      const props = __spreadValues({}, this.props);
      props.authContext = props.authContext || this.context;
      return React.createElement(component, props);
    }
  }, __publicField(_a, "contextType", AuthContextType), _a;
}
export {
  withAuthContext
};
//# sourceMappingURL=withAuthContext.js.map
